<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">

          <div class="card-header pb-0">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <h6 class="mb-0 me-auto">Lista de Inventario</h6>
              <div class="d-flex align-items-center gap-2">
                <router-link
                  :to="{ name: 'Supplies Create' }"
                  class="btn btn-sm btn-primary text-white"
                  title="Agregar insumo"
                >
                  <i class="fa fa-plus me-1"></i> Agregar
                </router-link>
                <button class="btn btn-sm btn-success" @click="exportToExcel" title="Exportar a Excel">
                  <i class="fas fa-file-excel me-1"></i> Exportar Excel
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar insumos..." @input="debouncedFetchData" />
              </div>
            </div>

          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <input
                ref="photoInput"
                type="file"
                class="d-none"
                accept="image/*;capture=camera"
                @change="onPhotoSelected"
              />

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Imagen</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producto</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ref</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Stock</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio de compra</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio de venta</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Semaforo</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ultima modificación</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">

                    <td class="align-middle text-center">
                      <button
                        type="button"
                        class="product-thumb-btn"
                        :title="productImages[value.id] ? 'Cambiar foto' : 'Tomar o seleccionar foto'"
                        :disabled="uploadingProductId === value.id"
                        @click="openPhotoPicker(value.id)"
                      >
                        <img
                          v-if="productImages[value.id]"
                          :src="imageUrl(productImages[value.id])"
                          alt=""
                          class="product-thumb-img"
                        />
                        <span v-else class="product-thumb-placeholder">
                          <i class="fas fa-camera"></i>
                        </span>
                      </button>
                    </td>

                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.name }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.ref }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ parseInt(value.quantity) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatMoney(value.price) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatMoney(value.sale_price) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-danger': value.quantity <= value.low,
                        'bg-gradient-warning': value.quantity > value.low && value.quantity <= value.medium,
                        'bg-gradient-success': value.quantity >= value.high,
                      }">

                        {{
                          value.quantity >= value.high
                            ? 'Alto'
                            : value.quantity > value.low
                              ? 'Medio'
                              : 'Bajo'
                        }}
                      </span>
                    </td>
                   
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm"
                        :class="value.status === 1 ? 'bg-gradient-success' : 'bg-gradient-warning'">
                        {{ value.status === 1 ? 'Activo' : 'Inactivo' }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(value.updated_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link
                        :to="{ name: 'Supplies Create', params: { data: JSON.stringify(value) }, props: true }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro">
                        <i class="fa fa-pencil-alt"></i>
                      </router-link>

                      <a
                        v-if="value.ref"
                        class="text-secondary font-weight-bold text-xs cursor-pointer wp-sync-btn"
                        style="margin-left: 15px;"
                        title="Sincronizar con WordPress (SKU)"
                        :class="{ 'opacity-50': syncingWordPressId === value.id }"
                        @click="syncWithWordPress(value)"
                      >
                        <i class="fab fa-wordpress" :class="{ 'fa-spin': syncingWordPressId === value.id }"></i>
                      </a>

                      <a @click="deleteUser(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>

                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="10" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                  <tr v-if="data.length > 0" class="bg-light">
                    <td colspan="3" class="text-end text-sm fw-bold">Total (todas las páginas filtradas):</td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-primary fw-bold">
                        {{ totalStockAllPages.toLocaleString('es-ES', { maximumFractionDigits: 0 }) }}
                      </span>
                      <div class="text-xxs text-muted">Unidades</div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-info fw-bold">{{ formatMoney(totalPurchaseValueAllPages) }}</span>
                      <div class="text-xxs text-muted">Valor compra invertido</div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-success fw-bold">{{ formatMoney(totalInventoryValueAllPages) }}</span>
                      <div class="text-xxs text-muted">Valor en inventario (venta)</div>
                    </td>
                    <td colspan="4"></td>
                  </tr>

                </tbody>
              </table>



              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer"
                  @click="fetchData(link.label)" :disabled="!link.url || link.active"
                  :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import debounce from '@/utils/debounce';
export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: '',
      totalStockAllPages: 0,
      totalPurchaseValueAllPages: 0,
      totalInventoryValueAllPages: 0,
      apiUrl: process.env.VUE_APP_API_IMAGE_URL || process.env.VUE_APP_API_BASE_URL,
      productImages: {},
      activeProductId: null,
      uploadingProductId: null,
      syncingWordPressId: null,
    };
  },
  computed: {
    ...mapGetters('inventory', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
      return this.$store.state.inventory.currentPage;
    },
    lastPage() {
      return this.$store.state.inventory.lastPage;
    },
    data() {
      return this.allData;
    },
    links() {
      return this.$store.getters['inventory/links'];
    },
  },
  methods: {
    formatMoney(value) {
      return parseFloat(value ?? 0).toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    imageUrl(media) {
      if (!media?.file_path) return '';
      return this.apiUrl + media.file_path;
    },
    openPhotoPicker(productId) {
      this.activeProductId = productId;
      this.$refs.photoInput?.click();
    },
    async onPhotoSelected(event) {
      const input = event?.target;
      const file = input?.files?.[0];
      if (!file || !this.activeProductId) {
        if (input) input.value = '';
        return;
      }
      const productId = this.activeProductId;
      this.uploadingProductId = productId;
      try {
        const formData = new FormData();
        formData.append('mediaable_id', productId);
        formData.append('mediaable_type', 'inventory');
        formData.append('file', file);

        const response = await this.$store.dispatch('media/save', formData);
        if (response && response.status >= 200 && response.status < 300) {
          await this.loadImageForProduct(productId);
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'La imagen se guardó correctamente.',
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          throw new Error(response?.data?.message || 'Error al subir la imagen');
        }
      } catch (error) {
        console.error('Error al subir imagen:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || error.message || 'Error al subir la imagen',
        });
      } finally {
        this.uploadingProductId = null;
        this.activeProductId = null;
        if (input) input.value = '';
      }
    },
    async loadImageForProduct(productId) {
      try {
        const media = await this.$store.dispatch('media/getData', productId);
        if (media?.data) {
          const list = Array.isArray(media.data) ? media.data : media.data.data || [];
          const inventoryImages = list.filter((item) => item.mediaable_type === 'inventory');
          if (inventoryImages.length > 0) {
            this.productImages = {
              ...this.productImages,
              [productId]: inventoryImages[inventoryImages.length - 1],
            };
          }
        }
      } catch (error) {
        console.error(`Error al cargar imagen del producto ${productId}:`, error);
      }
    },
    async loadProductImages() {
      const products = this.data || [];
      if (!products.length) return;
      const map = {};
      products.forEach((product) => {
        if (product.media && Array.isArray(product.media) && product.media.length > 0) {
          const inventoryImages = product.media.filter((item) => item.mediaable_type === 'inventory');
          if (inventoryImages.length > 0) {
            map[product.id] = inventoryImages[inventoryImages.length - 1];
          }
        }
      });
      this.productImages = map;
    },
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        page: pageUrl,
      };
      await this.$store.dispatch('inventory/fetchData', params);
      await this.fetchFilteredTotals();
      await this.loadProductImages();
    },
    async fetchFilteredTotals() {
      const params = {
        search: this.searchQuery || '',
      };
      const rows = await this.$store.dispatch('inventory/getAll', params);
      const list = Array.isArray(rows) ? rows : [];
      this.totalStockAllPages = list.reduce(
        (acc, item) => acc + parseFloat(item.quantity || 0),
        0
      );
      this.totalPurchaseValueAllPages = list.reduce(
        (acc, item) =>
          acc + parseFloat(item.quantity || 0) * parseFloat(item.price || 0),
        0
      );
      this.totalInventoryValueAllPages = list.reduce(
        (acc, item) =>
          acc + parseFloat(item.quantity || 0) * parseFloat(item.sale_price || 0),
        0
      );
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("inventory/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.fetchData();

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el usuario');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async syncWithWordPress(product) {
      if (!product?.id || !product?.ref) {
        await Swal.fire('Aviso', 'El producto debe tener referencia (SKU) para sincronizar.', 'warning');
        return;
      }
      this.syncingWordPressId = product.id;
      try {
        const response = await this.$store.dispatch('inventory/syncWordPress', product.id);
        const msg = response?.data?.message || 'Producto sincronizado con WooCommerce.';
        const action = response?.data?.data?.action;
        const imageSynced = response?.data?.data?.image_synced;
        const actionLabel = action === 'created' ? 'Creado' : 'Actualizado';
        await Swal.fire({
          icon: 'success',
          title: actionLabel,
          html: `${msg}<br><small class="text-muted">SKU: ${product.ref}${imageSynced ? ' · Imagen sincronizada' : ''}</small>`,
        });
      } catch (error) {
        const msg =
          error?.data?.message ||
          error?.response?.data?.message ||
          'No se pudo sincronizar con WordPress.';
        await Swal.fire('Error', msg, 'error');
      } finally {
        this.syncingWordPressId = null;
      }
    },
    async exportToExcel() {
      try {
        const filters = {};
        if (this.searchQuery) {
          filters.search = this.searchQuery;
        }

        const response = await this.$store.dispatch('inventory/exportData', filters);
        
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'inventario.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        
        window.URL.revokeObjectURL(url);
        
        await Swal.fire('Éxito', 'Archivo Excel exportado correctamente', 'success');
      } catch (error) {
        console.error('Error al exportar:', error);
        await Swal.fire('Error', 'No se pudo exportar el archivo Excel', 'error');
      }
    }

  },
  created() {
    this.debouncedFetchData = debounce(() => this.fetchData(null), 400);
  },
  mounted() {
    this.fetchData();
  },
  beforeUnmount() {
    if (this.debouncedFetchData) this.debouncedFetchData.cancel();
  },
};
</script>

<style scoped>
.product-thumb-btn {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 0;
  width: 48px;
  height: 48px;
  overflow: hidden;
  background: #f8f9fa;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.product-thumb-btn:disabled {
  opacity: 0.6;
  cursor: wait;
}

.product-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-thumb-placeholder {
  color: #6c757d;
  font-size: 1.1rem;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}

.wp-sync-btn .fa-wordpress {
  color: #21759b;
  font-size: 1.05rem;
}
</style>
